import React from 'react';

interface Props {
  unit: string;
  isGwiEquipment: boolean;
  hasCustomerLocations?: boolean;
}

export function RepairOrderEquipmentCell({ unit, isGwiEquipment, hasCustomerLocations }: Props) {
  if (!unit) return null;

  const content = isGwiEquipment ? (
    <a
      href={`/data-management/equipment-list?search=${encodeURIComponent(unit)}`}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(event) => event.stopPropagation()}
      className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300 hover:underline"
    >
      {unit}
    </a>
  ) : unit;

  return hasCustomerLocations ? (
    <span
      className="block rounded px-1.5 py-0.5 bg-amber-100 text-amber-950 dark:bg-amber-900/40 dark:text-amber-100"
      title="Customer locations assigned in Equipment List"
    >
      {content}
    </span>
  ) : <>{content}</>;
}
